<template>
  <router-view />
</template>

<script>
export default {
  name: 'TestSeriesIndex'
}
</script>
